module.exports = __webpack_public_path__ + "static/CrimsonText-SemiBold-4c53402ebe07b7f548d97c81e3f8273f.woff2";